import transformData from './transformData'
import { useAuth } from 'auth'
import { useEffect, useState } from 'react'

const useProfile = () => {
  const auth = useAuth()
  const { transformArrayObject } = transformData()
  const [optionsMajor, setOptionsMajor] = useState<any>([])

  useEffect(() => {
    if (auth.userProfile?.clinic_majors) {
      const options = transformArrayObject(
        auth.userProfile?.clinic_majors || [],
        {
          value: 'id',
          label: 'name'
        }
      )
      setOptionsMajor(options)
    }
  }, [auth.userProfile?.clinic_majors])
  if (auth?.userId) {
    localStorage.setItem('userIdOfClinic', auth.userId.toString())
  }
  return {
    profile: auth.userProfile,
    userId: auth.userId,
    reloadUserProfile: auth.reloadUserProfile!,
    setUserProfile: auth.setUserProfile,
    routes: auth?.routes,
    optionsMajor,
    isAuth: auth.isAuth
  }
}

export default useProfile
